import { persistStateTypes } from '../reducers/persistStateReducer';
import gameNames from '../hub/data/GameIds';

const GAME_ID = gameNames.CONNECT_IT;

export const initState = {
  savedText: 'my initial text',
  loading: false,
};

// Reducer for persistTest state. This updates the state of the app
// based off redux actions being fired to save and retrieve state.
// * savedText: String, the actual text the user has inputted and saved
// * loading: Bool, flag for whether to show the loading prompt or not based
// on the request state.
const persistTestReducer = (state = initState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    // If a request for gamestate has been sent, set loading flag
    // to "true"
    case persistStateTypes.REQUEST_GAMESTATE:
      return {
        ...state,
        loading: true,
      };

    // When gameState request is resolved, update state with GameData
    // and turn off loading flag
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
      return {
        ...state,
        loading: false,
        ...(action.stateData[GAME_ID].GameData || {}).gameDetails,
      };

    // When posting new gamestate, make sure our local redux state matches
    case persistStateTypes.POST_GAMESTATE:
      return {
        ...state,
        ...action.stateData,
      };

    // When getGameState returns an error, just load game w/ default state
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default persistTestReducer;
